import type { Store, StoreActions } from 'components/move-list/store/types';
import type { ContextMenu } from 'components/move-list/components/context-menu/config/types';
import { createAddComment } from './add-comment';
import { createAddCommentBefore } from './add-comment-before';
import { createAddAnnotation } from './add-annotation';
import { createAddAdditionalAnnotation } from './add-additional-annotation';
import { createHideAllAnnotations } from './hide-all-annotations';
import { createShowAllAnnotations } from './show-all-annotations';
import { createRemoveAnnotation } from './remove-annotation';
import { CONTEXT_MENU_ACTION_NAMES } from '../config/context-menu-action-names';
import { createPromoteVariation } from './promote-variation';
import { createDeleteMove } from './delete-move';
import { createDeleteComment } from './delete-comment';
import { createDeleteCommentBefore } from './delete-comment-before';
import { createClearAnalysis } from './clear-analysis';
import { createInsertContinuationAction } from './insert-continuation';
import { createMoveVariationUpAction } from './move-variation-up';
import { createMoveVariationDownAction } from './move-variation-down';
import { createSetFocus } from './node-limits/set-focus';
import { createSetBegin } from './node-limits/set-begin';
import { createSetEnd } from './node-limits/set-end';
import { createRemoveBegin } from './node-limits/remove-begin';
import { createRemoveFocus } from './node-limits/remove-focus';
import { createRemoveEnd } from './node-limits/remove-end';

/**
 * create context menu actions
 */
export function createContextMenuActions(
  store: Store,
  storeActions: StoreActions,
): Record<string, ContextMenu.Action> {
  return {
    [CONTEXT_MENU_ACTION_NAMES.AddAnnotation]: createAddAnnotation(store, storeActions),
    [CONTEXT_MENU_ACTION_NAMES.AddAdditionalAnnotation]: createAddAdditionalAnnotation(
      store,
      storeActions,
    ),
    [CONTEXT_MENU_ACTION_NAMES.AddCommentBefore]: createAddCommentBefore(store, storeActions),
    [CONTEXT_MENU_ACTION_NAMES.AddComment]: createAddComment(store, storeActions),
    [CONTEXT_MENU_ACTION_NAMES.DeleteCommentBefore]: createDeleteCommentBefore(store, storeActions),
    [CONTEXT_MENU_ACTION_NAMES.DeleteCommentAfter]: createDeleteComment(store, storeActions),
    [CONTEXT_MENU_ACTION_NAMES.RemoveAnnotation]: createRemoveAnnotation(store, storeActions),
    [CONTEXT_MENU_ACTION_NAMES.DeleteMove]: createDeleteMove(store, storeActions),
    [CONTEXT_MENU_ACTION_NAMES.PromoteVariation]: createPromoteVariation(store, storeActions),
    [CONTEXT_MENU_ACTION_NAMES.MoveVariationDown]: createMoveVariationDownAction(
      store,
      storeActions,
    ),
    [CONTEXT_MENU_ACTION_NAMES.MoveVariationUp]: createMoveVariationUpAction(store, storeActions),
    [CONTEXT_MENU_ACTION_NAMES.InsertContinuation]: createInsertContinuationAction(
      store,
      storeActions,
    ),
    [CONTEXT_MENU_ACTION_NAMES.ShowAllAnnotations]: createShowAllAnnotations(store, storeActions),
    [CONTEXT_MENU_ACTION_NAMES.HideAllAnnotations]: createHideAllAnnotations(store, storeActions),
    [CONTEXT_MENU_ACTION_NAMES.ClearAnalysis]: createClearAnalysis(store, storeActions),
    [CONTEXT_MENU_ACTION_NAMES.SetBegin]: createSetBegin(store, storeActions),
    [CONTEXT_MENU_ACTION_NAMES.SetFocus]: createSetFocus(store, storeActions),
    [CONTEXT_MENU_ACTION_NAMES.SetEnd]: createSetEnd(store, storeActions),
    [CONTEXT_MENU_ACTION_NAMES.RemoveBegin]: createRemoveBegin(store, storeActions),
    [CONTEXT_MENU_ACTION_NAMES.RemoveFocus]: createRemoveFocus(store, storeActions),
    [CONTEXT_MENU_ACTION_NAMES.RemoveEnd]: createRemoveEnd(store, storeActions),
  };
}
